import type {
    GetEventRoundResponseType,
    GetEventRoundRequestType
} from "./type";
import {
    request
} from "../request";

const threeTGetEventRound = async (args: GetEventRoundRequestType): Promise<GetEventRoundResponseType> => {
    return await request<GetEventRoundResponseType>(`/threeT/getEventRound?eventID=${args.eventID}&eventSubID=${args.eventSubID}&roundNo=${args.roundNo}`, {
        method: "GET"
    });
};

export default threeTGetEventRound;
